import React from 'react';
import Link from 'next/link';

import { SHOP_ROUTE_PREFIX } from 'src/constants/shopTaxonomy';

/**
 * Whether a breadcrumb href can be navigated client-side.
 *
 * Only taxonomy routes can: they are served by this web app and the taxonomy
 * content re-syncs from the URL, which is what makes a shallow transition safe.
 * The Homepage crumb belongs to another web app, so client-side routing cannot
 * resolve it.
 */
export const isSoftNavigableHref = (href?: string): boolean =>
  Boolean(href?.startsWith(SHOP_ROUTE_PREFIX));

/**
 * Breadcrumb link for taxonomy PLPs. Soft-transitions between taxonomy pages
 * with a real `<a href>` (so the trail stays crawlable), matching the shallow,
 * no-scroll, no-prefetch behaviour of the taxonomy nav; falls back to a plain
 * anchor for crumbs this app does not serve.
 */
export const TaxonomyBreadcrumbLink = ({
  children,
  href,
  ...props
}: React.AnchorHTMLAttributes<HTMLAnchorElement>) => {
  if (!isSoftNavigableHref(href)) {
    return (
      <a href={href} {...props}>
        {children}
      </a>
    );
  }

  return (
    <Link {...props} href={href!} prefetch={false} scroll={false} shallow>
      {children}
    </Link>
  );
};
